module.exports = __webpack_public_path__ + "img/logo.a8ac595d.svg";